export const DriveTrain = {
  None: 0,
  FWD: 1,
  RWD: 2,
  AWD: 3,
  FourXFour: 4,
}

export const DriveTrainOptions = [
  { label: 'FWD', value: DriveTrain.FWD },
  { label: 'RWD', value: DriveTrain.RWD },
  { label: 'AWD', value: DriveTrain.AWD },
  { label: '4x4', value: DriveTrain.FourXFour },
]

export const NormalizedDriveTrains = {
  1: 'FWD',
  2: 'RWD',
  3: 'AWD',
  4: 'FourXFour',
}
